document.addEventListener('DOMContentLoaded', function () {
  var articleContent = document.querySelector('.article-template__content');
  var tableOfContents = document.getElementById('table-of-contents');
  if (!articleContent || !tableOfContents) return;

  var headings = articleContent.querySelectorAll('h2, h3, h4, h5, h6');
  var stickyHeader = document.querySelector('[data-sticky-type="always"]');

  headings.forEach(function (heading, index) {
    var id = 'heading-' + index;
    heading.id = id;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = heading.textContent;
    li.classList.add('toc-' + heading.tagName.toLowerCase());

    a.addEventListener('click', function (e) {
      e.preventDefault();
      var headerHeight = stickyHeader
        ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10)
        : 0;
      var headingPosition = heading.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: headingPosition, behavior: 'smooth' });
    });

    li.appendChild(a);
    tableOfContents.appendChild(li);
  });
});
